module.exports = __webpack_public_path__ + "static/media/20180423_184126.3ae79b0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20180423_184126.jpg
// module id = 478
// module chunks = 0